import { createSlice } from '@reduxjs/toolkit'

export const UserClassesStatus = Object.freeze({
    Loading: 'loading',
    Success: 'success',
    Failure: 'failure',
})

const initialState = {
    status: null,
    errorMessage: '',
    classes: {},
    categories: {
        all: [],
        ongoing: [],
        completed: [],
        upcoming: [],
    },
}

const userClassesSlice = createSlice({
    name: 'userClasses',
    initialState,
    reducers: {
        getUserClassesRequest(state) {
            state.status = UserClassesStatus.Loading
            state.classes = []
            Object.keys(state.categories).forEach(category => {
                state.categories[category] = []
            })
            state.errorMessage = ''
        },
        getUserClassesRequestSuccess(state, action) {
            return {
                ...state,
                status: UserClassesStatus.Success,
                ...action.payload,
            }
        },
        getUserClassesRequestFailure(state, action) {
            state.status = UserClassesStatus.Failure
            state.errorMessage = action.payload
        },
    },
})

const {
    getUserClassesRequest,
    getUserClassesRequestSuccess,
    getUserClassesRequestFailure,
} = userClassesSlice.actions

export const userClassesActions = {
    getUserClassesRequest,
    getUserClassesRequestSuccess,
    getUserClassesRequestFailure,
}

export const userClassesSelectors = {
    isFetching: state => state.userClasses.status === UserClassesStatus.Loading,
    hasError: state => state.userClasses.status === UserClassesStatus.Failure,
    status: state => state.userClasses.status,
    errorMessage: state => state.userClasses.errorMessage,
    classes: state => state.userClasses.classes,
    categories: state => state.userClasses.categories,
}

export default userClassesSlice.reducer
